<ng-container *ngFor="let item of installmentPlans; let i = index">
  <app-installments-item
    *ngIf="isZeroInterest(item); else withInterest"
    [title]="getTitleString(item.monthlyCost, item.numberOfMonths)"
    [selected]="installmentPlans[i] === selectedPlan"
    badgeText="0% ränta"
    [bulletPoints]="getBulletPoints(item)"
    [isFirstItem]="isFirstItem(i)"
    [isLastItem]="isLastItem(i)"
    [color]="'#00ac84'"
    (click)="select(i)"
    [radioButtonColor]="primaryColor"
    [isDiscountedInterestRate]="false"
  ></app-installments-item>

  <ng-template #withInterest>
    <app-installments-item
      [title]="getTitleString(item.monthlyCost, item.numberOfMonths)"
      [selected]="installmentPlans[i] === selectedPlan"
      [bulletPoints]="getBulletPoints(item)"
      [isFirstItem]="isFirstItem(i)"
      [isLastItem]="isLastItem(i)"
      [color]="'#00ac84'"
      (click)="select(i)"
      [radioButtonColor]="primaryColor"
      [isDiscountedInterestRate]="false"
    ></app-installments-item>
  </ng-template>
</ng-container>
